import { render, staticRenderFns } from "./point_tip.vue?vue&type=template&id=9c026a90&scoped=true&"
import script from "./point_tip.vue?vue&type=script&lang=js&"
export * from "./point_tip.vue?vue&type=script&lang=js&"
import style0 from "./point_tip.vue?vue&type=style&index=0&id=9c026a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c026a90",
  null
  
)

export default component.exports